<div class="item-discount-dialog">
    <div class="discount-header flex-between-center p-4 border-bottom-lightest">
        <div class="discount-name w-100 flex-row">
            <img src="assets/img/icon/discount-icon.svg" />
            <div class="w-100 mr-3">
                <app-input id="discount-name" type="text" placeholder="Discount name" 
                    [fontSize]="14" [isInvalid]="error?.name"
                    name="name" [value]="discount.name" [maxLength]="50" 
                    (appChange)="handleChange('name', $event)"
                    (appFocus)="handleFocus('name')"
                    (appBlur)="handleBlur('name')">
                </app-input>
            </div>
        </div>
        <div class="flex-start-center pointer font-18 font-400 font-gray-65" (click)="handleClose(false)">
            <i class="fa fa-times"></i>
        </div>
    </div>

    <div class="discount-body p-4 flex-column gap-2rem">
        <div class="flex-row gap-1rem">
            <div class="ui-g-6 p-0">
                <app-input id="discount-amount" type="text" placeholder="Enter Amount" [fontSize]="14"
                    name="amount" [maxLength]="50" [selectTextOnFocus]="true" [floatingLabel]="true" [errorMessage]="error?.amountError"
                    [allowDecimal]="true" [isInvalid]="error?.amount" (appFocus)="handleFocus('amount')" (appBlur)="handleBlur('amount')"
                    [value]="focus?.amount ? discount?.amount : (discount?.amount || 0) | currency: usd" (appKeyUp)="handleChange('amount', $event)">
                </app-input>
            </div>
            <div class="ui-g-6 p-0">
                <app-dropdown field="label" styleClassDropdownList="top-38" [floatingLabel]="true"
                    [setPositionDynamically]="true"
                    [fontSize]="14" [hasBorderBottomOnActive]="true" placeholder="Taxable" [options]="taxableOptions"
                    [setPositionDynamically]="false" [isDropdownIconVisible]="true"
                    [value]="discount?.isTaxable ? taxableOptions[0] : taxableOptions[1]"
                    (appSelect)="handleChange('isTaxable', $event)">
                </app-dropdown>
            </div>
        </div>
        <div class="flex-row p-0">
            <div class="ui-g-12 p-0">
                <app-dropdown field="label" styleClassDropdownList="top-38" [floatingLabel]="true"
                    [setPositionDynamically]="true" [hasError]="error?.associatedWith"
                    [fontSize]="14" [hasBorderBottomOnActive]="true" placeholder="Associated with" [options]="associateWithOptions"
                    [setPositionDynamically]="false" [isDropdownIconVisible]="true"
                    [value]="discount?.associatedWith"
                    (appSelect)="handleChange('associatedWith', $event)">
                </app-dropdown>
            </div>
        </div>
    </div>

    <div class="discount-footer flex-end-center p-4 border-top-lightest gap-2">
        <button class="btn btn-white btn-submit" (click)="handleClose(false)">Cancel</button>
        <button class="btn btn-primary btn-submit" (click)="handleSubmit()">Save</button>
    </div>
</div>